module.exports = __webpack_public_path__ + "static/media/undraw_Work_time_re_hdyv.be3a343e.svg";